export const regex_iso_date = /^\d{4}-\d{2}-\d{2}$/;
